<!-- 
Large twirly-gig style loading indicator.

Use a v-if on the component to display or hide it.

These are normally used in situations where we don't know what the layout will be until after the data has loaded.
We also have an "OurBusyIndicator" component which is a slim, discreet component that's normally 
used at the top of dialog boxes while data is being loaded or saved.
-->
<template>
  <div class="text-xs-center ma-5 pa-5">
    <v-progress-circular size="120" width="7" color="grey" indeterminate>{{ caption }}</v-progress-circular>
  </div>
</template>

<script>
export default {
  props: {
    caption: {
      type: String,
      default: "Loading..."
    }
  }
};
</script>
